import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const Badge = ({ children, mods={'bg-yellow': true} }) => {
    const { className } = useMods(Badge, { mods });

    return (
        <span
            className={ className }
        >
            { children }
        </span>
    );
};

Badge.displayName = 'Badge';

Badge.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object
};

export default Badge;
